<template>
    <v-dialog max-width="900px" v-model="dialog" persistent>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 0px">
                    Chọn đề nghị mua hàng dịch vụ
                </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="close"
                icon
                style="
                    position: absolute;
                    right: 10px;
                    top: 10px;
                    color: #fff;
                "
            >
                <v-icon>cancel</v-icon>
            </v-btn>
            
            <c-search-form
                :rows-per-page-items="[10, 20, 50]"
                :form-name="formName"
                :fields="fields"
                key-property="req_ord_id"
                search-url="/requestOrder/getRequestPending"
                form-type="intable"
                ref="tableData"
                :acceptView="false"
                :acceptDelete="false"
                :acceptCreate="false"
                :acceptEdit="false"
                :acceptSelect="true"
                :displayToolbar="false"
                @selectItem="selectItem"
                :hiddenFields="hiddenFields"
            />

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="close">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CSearchForm from "../../../../components/form/ManageForm";
import axios from "axios";
import moment from "moment";
import { requestConstants } from "@/constants";

export default {
    name: "modal_order_request",
    components: { CSearchForm },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        areas: {
            type: Array,
            default: [],
        },
    },
    data: () => {
        return {
            formName: "Danh sách đề nghị mua hàng",
            hiddenFields: {
                byProcess: 3,
                status: 4,
            },
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "requestNumber",
                    text: "Số đề nghị",
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "requestDate",
                    text: "Ngày đề nghị",
                    headerStyle: "text-align:center",
                    dateFormat: 'dd/MM/yyyy',
                },
                {
                    value: "areaId",
                    text: "Khu nuôi",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "areaId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                // {
                //     value: "totalImportRequest",
                //     text: "Số thông báo đã tạo",
                //     headerStyle: "text-align:center",
                // },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: requestConstants.requestStatus["BUY"],
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    width: "5%",
                    text: "lang.common.actions",
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    watch: {
        areas: {
            handler(data) {
                let itemFields = this.fields.filter(function (e) {
                    return e.name == "areaId";
                });
                if (itemFields != undefined && itemFields.length > 0) {
                    itemFields[0].items = data;
                }
            },
            deep: true,
        },
    },

    created() {
        
    },

    methods: {
        close() {
            this.$emit("close");
        },
        selectItem(item) {
            this.$emit("selectRequest", item.reqOrdId);
        },
    },
    destroyed() {},
};
</script>
